(() => {
  const root = document.querySelector('[data-wld-faq]');
  if (!root) return;
  const input = root.querySelector('#wld-faq-search');
  const form = input.closest('form');
  const clear = root.querySelector('[data-wld-clear]');
  const reset = root.querySelector('[data-wld-reset]');
  const empty = root.querySelector('[data-wld-empty]');
  const heading = root.querySelector('[data-wld-heading]');
  const count = root.querySelector('[data-wld-results-count]');
  const filters = [...root.querySelectorAll('[data-wld-category]')];
  const questions = [...root.querySelectorAll('[data-wld-question]')];
  const normalize = (value) => value.toLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g, '').replace(/[’']/g, '').replace(/[^a-z0-9]+/g, ' ').trim();
  const indexed = questions.map((node) => ({node, text: normalize(node.textContent + ' ' + (node.dataset.search || ''))}));
  let category = 'all';
  filters.forEach((filter) => {
    const total = categoryCount(filter.dataset.wldCategory);
    const label = filter.querySelector('[data-wld-count]');
    if (label) label.textContent = total;
  });
  function categoryCount(key) { return questions.filter((node) => key === 'all' || node.dataset.category === key).length; }
  function render() {
    const terms = normalize(input.value).split(' ').filter(Boolean);
    let total = 0;
    indexed.forEach(({node, text}) => {
      const visible = (category === 'all' || node.dataset.category === category) && terms.every((term) => text.includes(term));
      node.hidden = !visible;
      if (visible) total += 1;
    });
    filters.forEach((filter) => filter.setAttribute('aria-pressed', String(filter.dataset.wldCategory === category)));
    const active = filters.find((filter) => filter.dataset.wldCategory === category);
    heading.textContent = terms.length ? root.dataset.searchLabel : active.textContent.replace(/\d+$/, '').trim();
    count.textContent = `${total} ${total === 1 ? root.dataset.oneAnswer : root.dataset.manyAnswers}`;
    empty.hidden = total !== 0;
    clear.hidden = input.value.length === 0;
  }
  function updateUrl() {
    const url = new URL(location.href);
    if (category === 'all') url.searchParams.delete('category');
    else url.searchParams.set('category', category);
    url.hash = '';
    history.pushState(null, '', url);
  }
  function openAnswer() {
    let id;
    try { id = decodeURIComponent(location.hash.slice(1)); } catch { return; }
    const answer = questions.find((node) => node.id === id);
    if (!answer) return;
    category = 'all';
    input.value = '';
    render();
    answer.open = true;
    requestAnimationFrame(() => answer.scrollIntoView({block:'start'}));
  }
  function readUrl() {
    const key = new URL(location.href).searchParams.get('category');
    category = filters.some((filter) => filter.dataset.wldCategory === key) ? key : 'all';
    render();
    openAnswer();
  }
  filters.forEach((filter) => filter.addEventListener('click', () => { category = filter.dataset.wldCategory; updateUrl(); render(); }));
  input.addEventListener('input', render);
  form.addEventListener('submit', (event) => { event.preventDefault(); render(); });
  clear.addEventListener('click', () => { input.value = ''; render(); input.focus(); });
  reset.addEventListener('click', () => { category = 'all'; input.value = ''; updateUrl(); render(); input.focus(); });
  window.addEventListener('hashchange', openAnswer);
  window.addEventListener('popstate', readUrl);
  root.querySelector('[data-wld-filters]').hidden = false;
  readUrl();
})();
